import { ImageFields } from '@boss/types/corporate-jobs';

const getImageProps = (entry: ImageFields) => {
  return {
    image: entry?.image,
    alt: entry?.altText,
    contain: entry?.containImage,
  };
};

export default getImageProps;
